import { createPortal } from 'react-dom';
import React from 'react';

type PortalComponentProps = {
  children: React.ReactNode;
  hasRef: boolean;
  modalContentRef: React.RefObject<HTMLDivElement>;
};

const PortalWrapper = ({ children, hasRef, modalContentRef }: PortalComponentProps) =>
  hasRef && modalContentRef.current ? createPortal(children, modalContentRef.current) : null;

export default PortalWrapper;
